import { useEffect, useRef, useState } from 'react';
import { Box, ButtonBase } from '@material-ui/core';
import Dialog from '../../../components/Dialog';
import Text from '../../../components/Text';
import StyleButton from '../../../components/StyleButton';
import { BsLinkIcon, CloseIcon } from '../../../components/Icon';
import QrCodeGenerator from '../../../components/QrCodeGenerator';
import CustomAlert from '../../../components/Alert/CustomAlert';
import { patientSurveyAPI } from '../../../apis';
import { useGetUserInfo } from '../../../utils';
import usePrintCanvas from '../../../utils/hooks/usePrintCanvas';

const SurveyGenQRCodePopup = ({ handleClose }) => {
  const [data, setData] = useState({
    qrCode: '',
    url: '',
  });
  const [linkCopyAlert, setLinkCopyAlert] = useState(false);
  const userInfo = useGetUserInfo();
  const qrCodeRef = useRef();
  const handlePrint = usePrintCanvas();

  const genPatientQrCode = async () => {
    try {
      const params = {
        dwpHospitalCode: userInfo.hospCode,
      };
      const { result } = await patientSurveyAPI.genPatientQrCode(params);
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    genPatientQrCode();
  }, []);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(data.url);
      setLinkCopyAlert(true);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = data.url;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setLinkCopyAlert(true);
      } catch (err) {
        console.log(err);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleDownload = () => {
    console.log('qrCodeRef', qrCodeRef);

    if (!qrCodeRef.current) return;
    // 生成 Data URL（默认 PNG 格式）
    const dataUrl = qrCodeRef.current.toDataURL('image/png');

    // 创建虚拟链接并触发下载
    const link = document.createElement('a');
    link.download = 'qrcode.png'; // 下载文件名
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog
      open={true}
      title="Generate QR Code"
      confirm="Download"
      handleClose={handleClose}
      handleConfirm={handleDownload}
      // handleConfirm={handlePrint(qrCodeRef)}
    >
      <>
        <Box display="flex" flexDirection="column" alignItems="center" pt="0.7rem">
          <QrCodeGenerator ref={qrCodeRef} url={data.url} />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mt="3rem"
            p="1.25rem"
            borderRadius="0.625rem"
            bgcolor="#F5FAFF"
            width="100%"
          >
            <Text color="#2e4469" fontSize="1rem" wordBreak="break-all" style={{ maxWidth: '75%' }}>
              {`URL: ${data.url}`}
            </Text>
            <StyleButton
              Icon={BsLinkIcon}
              text="Copy"
              type="fill"
              borderRadius="0.5rem"
              width="8.2rem"
              height="2.875rem"
              onClick={handleCopyLink}
            />
          </Box>
        </Box>
        {linkCopyAlert && (
          <CustomAlert autoClose timeout={4 * 1000} onClose={() => setLinkCopyAlert(false)}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              p="1.25rem 1.87rem"
              width="43.75rem"
              height="4.375rem"
              bgcolor="#A9EDDD"
              borderRadius="1rem"
              boxShadow="0px 0px 8px 0px rgba(0, 0, 0, 0.25)"
            >
              <Text fontSize="1.125rem" color="#2E4469">
                Link Copied
              </Text>
              <ButtonBase onClick={() => setLinkCopyAlert(false)}>
                <CloseIcon style={{ fontSize: '1.375rem', color: '#2E4469' }} />
              </ButtonBase>
            </Box>
          </CustomAlert>
        )}
      </>
    </Dialog>
  );
};

export default SurveyGenQRCodePopup;
